import css from "@emotion/css"

export const highlight = css`
  color: #6772e5;
  text-decoration: underline;
`
